import {
  wholesaleV2 as ApiService,
  wholesaleV2withMgr as ApiwholesaleV2withMgrService,
  wholesaleV2withAccount as ApiwholesaleV2withAccountService
} from './ApiService';
import { downloadFile } from '../Utils/apiHelper';
import { getCurrentCustomerFromLS } from './CoreService';

function prepareBalance(items) {
  let balance = items.shift().amount;

  return {
    startBalance: balance,
    list: items
      .map((item) => {
        balance += item.amount;
        return {
          ...item,
          balance,
        };
      })
      .reverse(),
  };
}

const from = 1;
const to = 1589989388332;

export default {
  fetchList([from, to]) {
    //https://wholesale.hoteos.net/api/v2
    const currentCustomer = getCurrentCustomerFromLS();
    return ApiwholesaleV2withMgrService.accessGet(`/invoices/list?customer_id=${currentCustomer.id}&from=${from}&to=${to}`);
  },
  fetchListNonMgr([from, to]) {
    //https://wholesale.hoteos.net/api/v2
    return ApiwholesaleV2withAccountService.accessGet(`/invoices/list?from=${from}&to=${to}`);
  },

  //   GET api/v2/mgr/invoices/invoices

  fetchListInvoices([from, to]) {
    const currentCustomer = getCurrentCustomerFromLS();
    return ApiwholesaleV2withMgrService.accessGet(`/invoices/invoices?customer_id=${currentCustomer.id}&from=${from}&to=${to}`);
  },


  fetchListReplenishments([from, to]) {
    const currentCustomer = getCurrentCustomerFromLS();
    return ApiwholesaleV2withMgrService.accessGet(`/invoices/invoices?customer_id=${currentCustomer.id}&from=${from}&to=${to}`);
  },

  // response:

  // {
  //  "total": 1,
  //  "offset": 1,
  //  "limit": 1,
  //  "page": [
  //     {

  //       "id": 123,
  //       "num": "String",
  //        "companyName": "String",
  //         "date": "String",
  //         "amount": 123.45,
  //         "orders": [1,2,3],
  //     "status": 1,    1 //Not paid  2 - Pending,  3 paid
  //     "statusStr": "String"

  //     }
  //  ]

  // }

  // GET api/v2/mgr/invoices/orders

  fetchListOrders([from, to]) {
    const currentCustomer = getCurrentCustomerFromLS();
    return ApiwholesaleV2withMgrService.accessGet(`/invoices/orders?customer_id=${currentCustomer.id}&from=${from}&to=${to}`);
  },

  fetchListReplenishments([from, to]) {
    const currentCustomer = getCurrentCustomerFromLS();
    return ApiService.accessGet(`/account/replenishments`);
  },

  topUpBalance(data) {
    return ApiService.accessPost(`/account/replenishments`, data)
  },

  // response:

  // {
  //  "total": 1,
  //  "offset": 1,
  //  "limit": 1,
  //  "page": [
  //     {

  //       "id": 123,
  //        "name": "String",
  //        "created": 123456,
  //         "date": 123456,
  //         "amount": 123.45,
  //       "send": 1,  //1 not sent, 2 sent, 3 error
  //     "status": 1,    1 //Not paid 2 paid
  //     "statusStr": "String"

  //     }
  //  ]
  // }


  downloadInvoicePDFMgr(invoiceId) {
    return ApiwholesaleV2withMgrService.accessGet(`/invoices/${invoiceId}/file`)
      .then(downloadFile);
  },

  downloadInvoicePDFClient(invoiceId) {
    return ApiwholesaleV2withAccountService.accessGet(`/invoices/${invoiceId}/file`)
      .then(response => {
        const data = new Blob([response], { type: 'application/pdf' });
        const fileName = `invoice_${invoiceId}.pdf`;
        const type = 'pdf';
        downloadFile({ data, fileName, type });
      })
  },

  getBalanceByUserId(id) {
    return ApiwholesaleV2withMgrService.get(`/customers/${id}`)
  },

  changeBalance(params) {
    return ApiwholesaleV2withMgrService.post(`/customer/transaction`, params);
  },

  createInvoice(data) {
    return ApiwholesaleV2withMgrService.post(`/invoices/fromorders`, data);
  },

  sendInvoicePaid(data) {
    return ApiwholesaleV2withMgrService.post(`/payments/invoices/${data[0].invoiceId}`, { amount: data[0].amount });
  },

  deleteInvoice(invoiceId) {
    return ApiwholesaleV2withMgrService.delete(`/invoices/${invoiceId}`);
  },

  generatePDF() {
    return ApiService.accessPost(`/invoice?from=${from}&to=${to}&fmt=pdf`).then(
      downloadFile
    );
  },
  generateCSV() {
    return ApiService.accessPost(`/invoice?from=${from}&to=${to}&fmt=csv`).then(
      downloadFile
    );
  },

  getCompaniesInfo() {
    return ApiwholesaleV2withMgrService.get(`/invoices/mycompanies`);
  },

  getInvoicesParams() {
    const currentCustomer = getCurrentCustomerFromLS();
    return ApiwholesaleV2withMgrService.get(`/invoices/customers/${currentCustomer.id}/params`);
  },

  createCompaniesInfo(data) {
    return ApiwholesaleV2withMgrService.post(`/invoices/mycompanies`, data);
  },

  editCompaniesInfo(data) {
    return ApiwholesaleV2withMgrService.patch(`/invoices/mycompanies/${data.id}`, data);
  },

  createInvoiceToInfo(data) {
    const currentCustomer = getCurrentCustomerFromLS();
    return ApiwholesaleV2withMgrService.post(`/invoices/customers/${currentCustomer.id}/params`, data);
  },

  // editInvoiceToInfo(data) {
  //   const currentCustomer = getCurrentCustomerFromLS();
  //   return ApiwholesaleV2withMgrService.patch(`/invoices/customers/${currentCustomer.id}/params/${data.id}`, data);
  // },

  editInvoiceToInfo(data, custId) {
    const currentCustomer = getCurrentCustomerFromLS();
    const id = (custId === null || custId === undefined) ? currentCustomer.id : custId
    return ApiwholesaleV2withMgrService.put(`/invoices/customers/${id}/params`, data);
  },

  uploadCompanyLogo(data) {
    return ApiwholesaleV2withMgrService.putOctetStream(`/invoices/mycompanies/${data.id}/logo`, data.payload, { headers: { 'Content-Type': 'application/octet-stream' } });
  },

  getCompanyLogo(companyId) {
    return ApiwholesaleV2withMgrService.accessGet(`/invoices/mycompanies/${companyId}/logo`);
  }

  // zeroizeBalance(id) {
  //   ApiwholesaleV2withMgrService.accessPost(`${crgm}/customers-zeroize-balance/${id}`);

  //   return new Promise((resolve) => {
  //     setTimeout(resolve, 1000, mockList);
  //   });
  // },

  //GET /api/v2/mgr/invoices/list
  // GET /api/v2/account/invoices/list
};
